export const DASHBOARD_TOP_BAR_HEIGHT = 36;
export const DASHBOARD_FOOTER_HEIGHT = 30;
